var _UserMenuContent;
import { useMainMenuTranslation } from "../../../hooks";
import MainMenuDrawer from "../../../ui/MainMenuDrawer";
import UserMenuContent from "../components/UserMenuContent";
import { jsx as _jsx } from "react/jsx-runtime";
var UserMenuMobileDrawer = function UserMenuMobileDrawer(_ref) {
  var isOpen = _ref.isOpen,
    onDismiss = _ref.onDismiss;
  var _useMainMenuTranslati = useMainMenuTranslation(),
    t = _useMainMenuTranslati.t;
  return /*#__PURE__*/_jsx(MainMenuDrawer, {
    title: t('USER_MENU_TITLE'),
    isOpen: isOpen,
    onDismiss: onDismiss,
    position: "right",
    children: _UserMenuContent || (_UserMenuContent = /*#__PURE__*/_jsx(UserMenuContent, {
      className: "flex-1"
    }))
  });
};
export default UserMenuMobileDrawer;